import ProdKind02 from './ProdKind02';
export default ProdKind02;
